import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import Refund from "../assets/about/refund.png";
import { Helmet } from "react-helmet-async";
function RefundPolicy() {
  return (
    <>
      <Helmet>
        <title>
          Refund Policy - Deetya Soft | Secure Call Management Services
        </title>
        <meta
          name="description"
          content="Read Deetya Soft's refund policy for toll-free and non-toll-free services. Transparent terms to ensure secure, fair, and reliable call management solutions."
        />
        <meta
          name="keywords"
          content="Deetya Soft Refund Policy, Refund Policy for IVR Services, Toll-Free Number Refund Terms, Non-Toll-Free Refund Policy India,Deetya Soft Call Management Refund, Fair Usage Refund Terms, IVR Service Cancellation Policy, Secure Call Service Guarantee, 30-Day Refund Policy Deetya Soft, Voice Service Refund India"
        />
        <link rel="canonical" href="https://deetyasoft.com/refund-policy" />

        {/* Facebook Meta Tags */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://deetyasoft.com/refund-policy"
        />
        <meta
          property="og:title"
          content="Refund Policy - Deetya Soft | Secure Call Management Services"
        />
        <meta
          property="og:description"
          content="Read Deetya Soft's refund policy for toll-free and non-toll-free services. Transparent terms to ensure secure, fair, and reliable call management solutions."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/refund.7c192ee1d71346f6f39b.png"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/refund-policy"
        />
        <meta
          name="twitter:title"
          content="Refund Policy - Deetya Soft | Secure Call Management Services"
        />
        <meta
          name="twitter:description"
          content="Read Deetya Soft's refund policy for toll-free and non-toll-free services. Transparent terms to ensure secure, fair, and reliable call management solutions."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/refund.7c192ee1d71346f6f39b.png"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        {/* General Meta */}
        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta httpEquiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* Structured Data Scripts */}
        <script type="application/ld+json">{`
          {
            "@context": "http://schema.org",
            "@type": "Organization",
            "name": "Deetya Soft Pvt Ltd",
            "description": "Read Deetya Soft's refund policy for toll-free and non-toll-free services. Transparent terms to ensure secure, fair, and reliable call management solutions.",
            "image": "https://deetyasoft.com/static/media/refund.7c192ee1d71346f6f39b.png",
            "logo": "https://www.deetyasoft.com/images/logo.png",
            "url": "https://www.deetyasoft.com",
            "telephone": ["+91-9015350505", "+91-9717055088"],
            "email": "info@deetyasoft.com",
            "sameAs": [
              "https://www.linkedin.com/company/deetya-soft-private-limited",
              "https://www.facebook.com/deetyasoftprivatelimited",
              "https://www.instagram.com/deetyasoft",
              "https://www.youtube.com/@deetyasoft",
              "https://www.crunchbase.com/organization/deetyasoft"
            ],
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
              "addressLocality": "Ghaziabad",
              "addressRegion": "Uttar Pradesh",
              "postalCode": "201014",
              "addressCountry": "IN"
            }
          }
        `}</script>

        <script type="application/ld+json">{`
          {
            "@context": "http://schema.org",
            "@type": "Organization",
            "url": "https://www.deetyasoft.com",
            "contactPoint": [
              {
                "@type": "ContactPoint",
                "telephone": "+91-981-862-7588",
                "contactType": "technical support",
                "areaServed": "IN"
              },
              {
                "@type": "ContactPoint",
                "telephone": "+91-901-535-0505",
                "contactType": "sales",
                "areaServed": "IN"
              }
            ]
          }
        `}</script>

        <script type="application/ld+json">{`
          {
            "@context": "http://schema.org",
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Parshan"
            },
            "reviewBody": "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
            "url": "https://www.deetyasoft.com/",
            "description": "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
            "datePublished": "2025-06-17",
            "name": "Deetya Soft Pvt Ltd",
            "reviewRating": {
              "@type": "Rating",
              "worstRating": "1",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "itemReviewed": {
              "@type": "Organization",
              "name": "Deetya Soft Pvt Ltd"
            }
          }
        `}</script>
      </Helmet>
      <div
        className="relative text-center py-16  bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${Refund})` }}
      >
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="flex mx-auto items-center justify-center">
          <div className="relative max-w-3xl px-6 py-2">
            {/* <div className="absolute rounded-xl inset-0 bg-[rgba(0,0,0,0.2)]"></div> */}
            <div className="relative z-10 text-white drop-shadow-xl flex flex-col items-center justify-center h-full">
              <h1 className="md:text-4xl text-2xl uppercase font-bold mb-4">
                Refund Policy
              </h1>
              <div className="flex items-center space-x-2 text-sm md:text-base">
                <Link
                  to="/"
                  className="text-white  hover:text-main1 font-semibold"
                >
                  Home
                </Link>
                <span className="">
                  <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
                </span>
                <span className="text-gray-300 hover:text-main1">
                  {" "}
                  Refund Policy
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full">
        {/* Content Section */}
        <div className="w-full bg-white  px-2">
          <div className=" bg-gray-50 rounded-2xl shadow-lg p-2 md:p-6">
            {/* Hero Section */}
            <div className="flex flex-col-reverse md:flex-row items-center gap-8">
              {/* Text */}
              <div className="w-full md:w-1/2">
                <h2 className="text-xl md:text-3xl font-semibold text-orangeheading mb-2">
                  Our Refund Promise
                </h2>
                <p className="text-gray-700 md:pl-0  pl-2 mb-4">
                  Deetya Soft Private Limited will refund the fee in accordance
                  with our refund policy. We aim to eliminate business risks for
                  clients by providing robust call management solutions trusted
                  by thousands of users daily.
                </p>
                <p className="text-gray-700 md:pl-0  pl-2">
                  This policy is applicable for both toll-free and non-toll-free
                  numbers. We expect clients to maintain fair usage standards to
                  be eligible for a refund.
                </p>
              </div>
            </div>

            {/* Terms & Conditions */}
            <div className="mt-6">
              <h3 className="md:text-3xl text-xl font-semibold text-orangeheading mb-2">
                However, the refund will be governed by certain terms and
                conditions.
              </h3>
              <ul className="list-decimal pl-6 md:text-base  text-[14px] text-gray-700 space-y-2">
                <li>
                  Deetya Soft is not obliged to make any refund if the
                  subscriptions have been bought at a discount of 10% or more;
                </li>
                <li>
                  If any additional document OR information is needed due to any
                  reason.
                </li>
                <li>
                  If the Client is indulging OR has indulged in any illegal
                  activities under any applicable laws
                </li>
                <li>
                  Refund claims will only be processed if the refund has been
                  sought within 30 days of the Activation.
                </li>
                <li>
                  A refund of a number is possible if it is not activated within
                  30 days from the date of the first payment.
                </li>
              </ul>

              <p className="mt-8 text-gray-600  text-center md:text-left">
                <strong className=" text-red-500">Note:</strong> Refund requests
                will not be entertained after 30 days from the service
                activation date.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RefundPolicy;
